import {gsap} from "gsap";

let menuItem = document.querySelector('.products-sub');
let subMenu = menuItem.querySelector('.sub-menu');
let headerIconSearch = document.querySelector('.header__search');
let headerCloseSearch = document.querySelector('.header__search--close');
let headerSearch = document.querySelector('.header__search--active');
let menuItemLinks = document.querySelectorAll('.products-sub > .sub-menu > .menu-item > a');
let lastScroll = 0;
let header = document.querySelector('header');

let menuItems = document.querySelectorAll('#header__menu > li > a')

let dakrMenuItems = document.querySelectorAll('.dark-menu a')

if(menuItems.length > 0){
    menuItems.forEach(a  => {
        a.addEventListener('mouseout', function(){
            menuItems.forEach(x => {
                if(!x.classList.contains('disabled')){
                    x.style.color = '#fff'
                }
            })
        })
    })

    menuItems.forEach(a  => {
        a.addEventListener('mouseover', function(){
            menuItems.forEach(x => {
                x.style.color = '#595957'
                x.classList.remove('disabled');
                if(!x.parentElement.classList.contains('product-sub')){
                    subMenu.classList.remove('active')
                }
            })
            a.style.color = '#fff'
        })
    })
}

if (menuItem) {
    menuItem.addEventListener('click', function (event) {
        event.preventDefault();
        subMenu.classList.toggle('active')
        dakrMenuItems.forEach(i => {
            i.classList.toggle('disabled')
        })
    });
}


if (menuItemLinks) {
    menuItemLinks.forEach(function (menuItemLink) {
        menuItemLink.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });
}

if (headerIconSearch) {
    headerIconSearch.addEventListener('click', function handleClick(event) {
       event.preventDefault()
        if (headerSearch) {
            headerSearch.classList.add('active')
        }
    });
}
if (headerCloseSearch) {
    headerCloseSearch.addEventListener('click', function handleClick(event) {
        event.preventDefault()
        if (headerSearch) {
            headerSearch.classList.remove('active')
        }
    });
}
window.addEventListener('DOMContentLoaded', () => {

    const burgerTl = gsap.timeline({paused: true, reversed: true, pin:true});
    burgerTl.to('.header__navigation', {right: 0});
    burgerTl.to('.header__menu li a span' ,{opacity: 1, y: 0}, 1);
    burgerTl.to('.menu_image' ,{opacity: 1},1);
    burgerTl.to('.sub-menu' ,{css:{borderColor:"#595957"},},1);
    burgerTl.to('.sub-menu .menu-item.sub-category a span, .social-icon svg, .terms li a' ,{opacity: 1, y: 0}, 1);

    // const burger = document.querySelector('.header__burger');
    const burgerMenu = document.querySelector('.header__burger--menu');
    const burgerClose = document.querySelector('.header__burger--close');

    if (burgerMenu) {
        burgerMenu.addEventListener('click', function (e) {
            document.querySelector('header').classList.add('header--menu-open');
            document.body.classList.add('header--menu-open');
            burgerClose.style.display = "flex";
            burgerMenu.style.display = "none";
            burgerTl.play()
        });
    }
    if (burgerClose) {
        burgerClose.addEventListener('click', function (e) {
            document.querySelector('header').classList.remove('header--menu-open');
            document.body.classList.remove('header--menu-open');
            burgerClose.style.display = "none";
            burgerMenu.style.display = "flex";
            burgerTl.reverse();
        });
    }

});

window.addEventListener('scroll', () => {
    const scroll = window.pageYOffset;
    if (lastScroll - scroll > 0 && scroll > 300) {
        header.classList.add('sticky-menu');
    } else {
        header.classList.remove('sticky-menu');
    }
    if (lastScroll - scroll < 0 && scroll > 200) {
        header.classList.add('hidden-top');
    } else {
        header.classList.remove('hidden-top');
    }
    lastScroll = scroll;
});
